export const TOGGLE_DEBUG_MODE = 'TOGGLE_DEBUG_MODE';
export type TOGGLE_DEBUG_MODE = typeof TOGGLE_DEBUG_MODE;

export const ADD_CONSOLE_MESSAGE = 'ADD_CONSOLE_MESSAGE';
export type ADD_CONSOLE_MESSAGE = typeof ADD_CONSOLE_MESSAGE;

export const CLEAR_CONSOLE_MESSAGE = 'CLEAR_CONSOLE_MESSAGE';
export type CLEAR_CONSOLE_MESSAGE = typeof CLEAR_CONSOLE_MESSAGE;


// WEBPACK FOOTER //
// ./src/store/Utilities/constant.ts